import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/nominas/descuentos-carga-externa-archivo-empleado/';
/**
 * GET
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getExternaDescuentosDetalle = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET - Solo los ids que coinciden con los filtros (ej. descuento_carga_externa_archivo),
 * sin pasar por el serializer completo. Pensado para "seleccionar todos" en la tabla,
 * donde traer cada fila completa de un archivo con miles de registros es lento y pesado.
 * @param {object} params
 * @returns {Promise<number[]>}
 */
export const getExternaDescuentosDetalleIds = async (params) => {
  try {
    const response = await API.get(`${baseURI}ids/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getExternaDescuentoDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postExternaDescuentoDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchExternaDescuentoDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteExternaDescuentoDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST - Elimina en bloque (asíncrono, vía Celery) una lista de ids. Devuelve de
 * inmediato la `descripcion` del ProcesoEnCursoTerminado a consultar por polling.
 * @param {number[]} ids
 * @returns {Promise<{descripcion: string}|boolean>}
 */
export const eliminarExternaDescuentosDetalleBulk = async (ids) => {
  try {
    const response = await API.post(`${baseURI}eliminar-bulk/`, { ids });
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const autorizarExternaDescuentoDetalle = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
